import { CoverageProvider, useCoverage } from "./context/CoverageContext";
import { HubLandscapeGrid } from "./components/HubLandscapeGrid";
import { HubDetailPanel } from "./components/HubDetailSheet";
import { CoverageFilterBar } from "./components/CoverageFilterBar";
import { ProductivityChart } from "./components/ProductivityChart";
import { HubWorkFilesPanel } from "./components/HubWorkFilesPanel";
import {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
} from "@/modern/components/ui/resizable";

const CoverageViewContent = () => {
  const { selectedHub } = useCoverage();

  return (
    <div className="coverage-page flex flex-col h-full w-full overflow-hidden bg-background">
      <div className="shrink-0 px-5 pt-5 pb-3">
        <ProductivityChart />
      </div>

      <div className="flex flex-1 min-h-0 px-5 pb-3 gap-3">
        <ResizablePanelGroup orientation="horizontal" className="flex-1 min-w-0">
          <ResizablePanel id="coverage-hub-list" maxSize={"75%"}>
            <div className="flex flex-col h-full overflow-hidden pr-2.5">
              <div className="shrink-0">
                <CoverageFilterBar />
              </div>
              <div className="flex-1 min-h-0 overflow-y-auto">
                <HubLandscapeGrid />
              </div>
            </div>
          </ResizablePanel>

          {selectedHub && (
            <>
              <ResizableHandle withHandle />
              <ResizablePanel
                id="coverage-detail"
                defaultSize={"30%"}
                maxSize={"55%"}
              >
                <div className="h-full overflow-hidden flex flex-col rounded-xl border border-border ml-3.5">
                  <HubDetailPanel />
                </div>
              </ResizablePanel>

              <ResizableHandle withHandle />
              <ResizablePanel
                id="coverage-workfiles"
                defaultSize={"22%"}
                maxSize={"40%"}
              >
                <div className="h-full overflow-hidden flex flex-col rounded-xl border border-border ml-3.5">
                  <HubWorkFilesPanel />
                </div>
              </ResizablePanel>
            </>
          )}
        </ResizablePanelGroup>
      </div>
    </div>
  );
};

const CoverageView = () => {
  return (
    <CoverageProvider>
      <CoverageViewContent />
    </CoverageProvider>
  );
};

export default CoverageView;
